import type { UserInfo } from '$lib/auth';

export const getUserDisplayName = (user: UserInfo): string => {
  if (user.given_name && user.family_name) {
    return `${user.given_name} ${user.family_name}`;
  }

  if (user.preferred_username) {
    return user.preferred_username;
  }

  return user.name ?? '';
};

export const getUserFirstName = (user: UserInfo): string => {
  const fromGiven = user.given_name?.trim() ?? '';
  if (fromGiven !== '') {
    return fromGiven;
  }

  const fromPreferred = user.preferred_username?.trim() ?? '';
  if (fromPreferred !== '') {
    return fromPreferred.split(' ')[0] ?? '';
  }

  const fromName = user.name?.trim() ?? '';
  return fromName.split(' ')[0] ?? '';
};

export const getDefaultOrgName = (user: UserInfo | undefined): string => {
  const firstName = user ? getUserFirstName(user) : '';
  return firstName === '' ? 'My Org' : `${firstName}'s Org`;
};

export const getUserInitials = (user: UserInfo): string => {
  const displayName = getUserDisplayName(user);

  return displayName
    .split(' ')
    .map((name) => name[0])
    .join('');
};
